module.exports = __webpack_public_path__ + "img/download-inventory-active.f43d2516.png";